import { render, staticRenderFns } from "./SingleImageEdit.vue?vue&type=template&id=70bdb85e&scoped=true"
import script from "./SingleImageEdit.vue?vue&type=script&lang=js"
export * from "./SingleImageEdit.vue?vue&type=script&lang=js"
import style0 from "./SingleImageEdit.vue?vue&type=style&index=0&id=70bdb85e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bdb85e",
  null
  
)

export default component.exports